import { observer, useStore } from "../../../service/mobx";
import { useDialog } from "../../Card/External/Video";
import ListItemEntity from "../../List/ListItem";

function SearchList({ entity }) {
  const { analytics, search } = useStore();
  const type = entity.__typename.toLowerCase();
  const playVideo = useDialog(type === "video" ? entity : undefined);

  return (
    <ListItemEntity
      entity={entity}
      onMouseEnter={() => search.set.suggestedEntityInFocus(entity)}
      onClick={() => {
        analytics.track.event("Search Suggestion", { type, id: entity.id });

        if (type === "video") {
          playVideo();
        }
      }}
    />
  );
}

export default observer(SearchList);
